import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { Download } from "lucide-react";
 * // Use <Download /> instead
 */
export const ExportIcon = createSVGWrapper(
  <>
    <path
      d="M11 5.17157L8.58578 7.58579L7.17157 6.17157L10.5858 2.75736C11.3668 1.97631 12.6332 1.97631 13.4142 2.75736L16.8284 6.17157L15.4142 7.58579L13 5.17157V15H11L11 5.17157Z"
      fill="currentColor"
    />
    <path
      d="M8 10H4C3.44772 10 3 10.4477 3 11V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V11C21 10.4477 20.5523 10 20 10H16V12H19V19H5V12H8V10Z"
      fill="currentColor"
    />
  </>
);
